import React, { useContext, useState } from "react";
import { AccountCircle, ExpandMore, ExpandLess, Menu } from "@material-ui/icons";
import { Grid, Hidden, Drawer } from "@material-ui/core";
import styles from "./header.module.scss";
import SideNavbar from "./sideNavbar";
import { Context as AuthContext } from "../../context/AuthContext";
import { useHistory, useLocation } from "react-router-dom";

const Header = () => {
  const { logout, state } = useContext(AuthContext);
  let history = useHistory();
  let location = useLocation();
  const [showSidebar, setShowSidebar ] = useState(false);
  const loginData = state.userData;

  const endSession = async () => {
    let { from } = location.state || { from: { pathname: "/login" } };
    await logout();
    history.replace(from);
    // window.location.reload();
  };

  const toggleSidebar = () => {
    setShowSidebar(!showSidebar);
  }

  return (
    <div>
      <nav
        className={`${styles.navContainer} navbar fixed-top navbar-light bg-white grid`}
      >
        <div>
          <Grid container spacing={2}>
            <Hidden mdUp>
              <Grid item onClick={toggleSidebar}>
                  <Menu />
              </Grid>
            </Hidden>
            <Grid item>
              <div id={styles.logo} className="flex-1">
                <img
                  src="/images/GoStor_main.svg"
                  width="85px"
                  height="auto"
                  alt="Logo"
                />
            </div>
            </Grid>
          </Grid>
        
          
        </div>
        <div className="justify-content-end" style={{ padding: "10px" }}>
          <div className={`${styles.profile} ${styles.dropdown}`}>
            <AccountCircle />
             <Hidden smDown>
              <div id={styles.userName}>
                {loginData && loginData.name ? loginData.name : null}
              </div>
             </Hidden>
            <ExpandMore id={styles.expand} fontSize="small" />
            <ExpandLess id={styles.expandLess} fontSize="small" />
            <div className={styles.dropdownContent}>
              {/* <Link to='/profile' id={styles.linkItem}> Manage Profile</Link> */}
               <Hidden mdUp>
                <div className="py-1">
                  <strong>
                    {loginData && loginData.name ? loginData.name : null}
                  </strong>
                </div>
               </Hidden>
              <div className="py-1">
                <a href="https://gostor.com/seller-policy" target="_blank" rel="noreferrer" style={{ padding: 0, background: "none" }}>Seller Policy</a>
              </div>
              <div onClick={() => endSession()} className="py-1">Logout</div>
            </div>
          </div>
        </div>
      </nav>
     
      <Hidden smDown>
        <div style={{paddingTop: 64}}>
        <SideNavbar />
        </div>
      </Hidden>
      <Drawer
        anchor="left"
        open={showSidebar}
        onClose={toggleSidebar}
        onClick={toggleSidebar}
      >
        <SideNavbar />
      </Drawer>
    </div>
  );
};

export default Header;
